import React from "react";
import { GradeTableChildrenWrapper, GradeTableWrapper } from "./styles";
import { Ptag } from "../../../components/fonts";

function GradeTable({ title, headers, body, children, style }) {
  return (
    <GradeTableWrapper style={style}>
      {title && <header>{title}</header>}
      {!children ? (
        <table>
          <thead>
            <tr>
              {headers.map((header) => (
                <th>
                  <Ptag
                    fontSize="14px"
                    fontWeight="500"
                    color="#4A4A4A"
                    style={{
                      textAlign: "center",
                      padding: "12px",
                    }}
                  >
                    {header}
                  </Ptag>
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {body.map((row) => (
              <tr>
                {row.map((cell, index) => (
                  <td>
                    <Ptag
                      style={{
                        textAlign: "center",
                        padding: "12px",
                      }}
                      fontSize="14px"
                      fontWeight={index === 0 ? "600" : "500"}
                      color="#4A4A4A"
                    >
                      {cell}
                    </Ptag>
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      ) : (
        <GradeTableChildrenWrapper>{children}</GradeTableChildrenWrapper>
      )}
    </GradeTableWrapper>
  );
}

export default GradeTable;
